<template>
    <!--            &#45;&#45; Tailwind UI -> Data Display -> Description Lists -> Left-aligned in card &#45;&#45;-->
    <div class="w-full bg-white border border-t-0 border-gray-200 overflow-hidden sm:rounded-b-lg">
        <div class="px-4 py-5 border-b border-gray-200 sm:px-6">
            <p class="mt-1 text-sm leading-5 text-gray-500">
                When you resolve an alarm, it is considered closed and new alarms may be generated.
                <!--                TODO: Can/Should we indicate if an alarm would be created right now?-->
            </p>
        </div>
        <div class="px-4 py-5 sm:p-0">
            <dl>
                <div class="mt-2 sm:mt-0 sm:grid sm:grid-cols-4 sm:gap-6 sm:px-6 sm:py-5">
                    <dt class="text-sm leading-5 font-medium text-gray-500">
                        Reason
                    </dt>
                    <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-3">
                        <select v-model="reason"
                                :class="reason === '' ? 'text-gray-400' : 'text-gray-900'"
                                class="bg-white p-2 w-full rounded-lg border border-gray-300">
                            <option value="" selected="selected" disabled class="text-gray-900">Please select an alarm reason</option>
                            <option value="Point is back within desired range">Point is back within desired range
                            </option>
                            <option value="Routine maintenance was performed">Routine maintenance was performed</option>
                            <option value="Point is back online">Point is back online</option>
                            <option value="Corrective action taken">Corrective action taken</option>
                            <option value="Other">Other</option>
                        </select>
                    </dd>
                </div>
            </dl>
        </div>
        <div class="px-4 py-5 sm:p-0">
            <dl>
                <div class="mt-2 sm:mt-0 sm:grid sm:grid-cols-4 sm:gap-6 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5">
                    <dt class="text-sm leading-5 font-medium text-gray-500">
                        Comments<span v-if="requireComment" class="text-red-500 ml-0.5">*</span>
                        <p v-if="requireComment" class="mt-1 text-base font-normal text-gray-500">
                            {{ policyText('requireComment') }}
                        </p>
                    </dt>
                    <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-3">
                        <textarea v-model="comments" class="block w-full rounded-md border-0 py-1.5 px-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6" rows="4" placeholder="Enter any comments here"></textarea>
                    </dd>
                </div>
            </dl>
        </div>
        <div class="px-4 py-5 sm:border-t mt-2 p-1">
            <dl class="mb-0 flex flex-col gap-4 sm:flex-row sm:items-center">
                    <!-- Left slot always present so the button stays pinned right whether or not the
                         re-alarm callout is shown (avoids the button shifting when willAlarm resolves). -->
                    <div class="sm:flex-1">
                        <!-- Re-alarm warning: plain inline callout (icon + red text, no box). -->
                        <alert v-if="willAlarm" color="danger" plain lead="Point still in alarm:" class="mb-0">
                            it may re-alarm if you resolve it.
                        </alert>
                    </div>
                    <span class="inline-flex w-full rounded-md sm:w-auto sm:shrink-0" :class="submitDisabled ? 'cursor-not-allowed' : ''">
                        <button type="button"
                                @click="sendFormData"
                                :disabled="submitDisabled"
                                :class="submitDisabled ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-500 active:bg-blue-700 cursor-pointer'"
                                class="w-full inline-flex items-center justify-center min-w-80 px-4 py-2 border border-transparent font-medium rounded-md text-white focus:outline-none focus:border-blue-700 focus:ring-indigo-200 sm:w-auto sm:text-sm sm:leading-5">
                          Resolve Alarm
                        </button>
                      </span>
            </dl>
        </div>
    </div>

</template>

<script>
    import axios from "axios";
    import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
    import { alarmPolicyText } from "@/support/alarmPolicyCopy";
    //https://michaelnthiessen.com/this-is-undefined/

    export default {
        name: "alarmAddressResolve",
        props: {
            isMassResolving: Boolean,
            sendEventOnly: Boolean,
            requireComment: {
                type: Boolean,
                default: false,
            },
        },
        mixins: [SonicuCoreMixin],
        data() {
            return {
                comments: '',
                reason: '',
                willAlarmObject: null,
            }
        },
        computed: {
            anythingSelected() {
                return this.reason.length > 0;
            },
            commentFilled() {
                return !!this.comments && this.comments.trim().length > 0;
            },
            submitDisabled() {
                return !this.anythingSelected || (this.requireComment && !this.commentFilled);
            },
            willAlarm() {
                if(this.willAlarmObject === null){
                    return false;
                }
                if(this.willAlarmObject.type === false){
                    return false;
                }
                if(this.willAlarmObject.type == 'offline'){
                    return "it's offline";
                }
                if(this.willAlarmObject.type == 'threshold'){
                    return "it's outside of its thresholds";
                }
                return false;
            }
        },
        methods: {
            policyText(key) {
                return alarmPolicyText(key);
            },
            sendFormData() {
                let data = {
                    'addressed': 'resolve',
                    'reason': this.reason,
                    'comments': this.comments,
                }

                if (this.sendEventOnly) {
                    // If we're only sending the event, emit the event and return
                    this.$emit('resolving-alarm', data)
                    return
                }

                axios.patch(window.location.pathname, data
                ).then(response => {
                        window.location.href = this.company.buildCompanyRoute('alarms');
                        return false;
                    }
                );
            },
            checkCurrentPointStatus() {
                axios.get('/api-internal' + window.location.pathname + '/current-point-status')
                    .then(data => {
                        console.log(data);
                        this.willAlarmObject = data.data;
                    });
            }
        },
        mounted() {
            if (! this.isMassResolving) {
                this.checkCurrentPointStatus();
            }
        }
    }
</script>

<style scoped>

</style>